/**
 * CU2_TOKENS — JS-accessible CU2 color constants for Recharts SVG props and other
 * cases where Tailwind classes cannot be used (e.g., stroke={}, fill={}).
 *
 * CSS custom properties (--cu2-*) are defined in :root via index.css (Plan 15-02).
 * Until Plan 15-02 lands, these var() references resolve to the browser default (transparent).
 * After Plan 15-02, they resolve to the correct CU2 brand colors.
 *
 * Component files must NOT import raw hex values. Reference CU2_TOKENS for any
 * programmatic color usage.
 */
export const CU2_TOKENS = {
  navy:   'var(--cu2-navy)',
  blue:   'var(--cu2-blue)',
  violet: 'var(--cu2-violet)',
  teal:   'var(--cu2-teal)',
  amber:  'var(--cu2-amber)',
  red:    'var(--cu2-red)',
  gray:   'var(--cu2-gray)',  // chart grid lines
} as const;

export type Cu2TokenKey = keyof typeof CU2_TOKENS;
